import { request } from ".";

export type FinancialSession = {
  service_id: number;
  data: string;
  colaborador_id: number;
  colaborador_nome: string;
  psicologo_id: number;
  psicologo_nome: string;
  empresa_id: number;
  empresa_nome: string;
  valor: number;
  pago: boolean;
  particular: boolean;
  responsavel_pagamento: "Empresa" | "Colaborador";
};

export type FinancialPayableSession = {
  service_id: number;
  data: string;
  colaborador_nome: string;
  psicologo_id: number;
  psicologo_nome: string;
  psicologo_email: string | null;
  empresa_nome: string;
  valor_sessao: number;
  valor_psicologo: number;
};

export type PendenciaEmpresa = {
  empresa_id: number;
  empresa_nome: string;
  sessoes_pendentes: number;
  valor_sessoes_pendente: number;
  mensalidade_pendente: number;
  valor_total_pendente: number;
  sessoes: {
    service_id: number;
    data: string;
    colaborador_id: number;
    psicologo_id: number;
    valor: number;
  }[];
};

export type PagamentoPsicologo = {
  psicologo_id: number;
  psicologo_nome: string;
  psicologo_email: string | null;
  valor_por_sessao: number;
  total_sessoes: number;
  valor_total_a_pagar: number;
};

export type DevedorColaborador = {
  colaborador_id: number;
  colaborador_nome: string;
  empresa_id: number;
  empresa_nome: string;
  sessoes_pendentes: number;
  valor_total_pendente: number;
};

export type FinancialTotals = {
  // Pendentes
  total_a_receber_empresas: number;       // sessões pendentes + mensalidades pendentes
  total_a_receber_colaboradores: number;  // sessões particulares não pagas
  total_mensalidades_pendentes: number;
  total_mensalidades_quitadas: number;
  total_a_receber_previsao: number;       // total geral previsto (empresas + colaboradores)
  // Recebidos
  total_recebido_empresas: number;        // mensalidades quitadas
  total_recebido_colaboradores: number;   // sessões particulares já pagas
  // Custos e resultado
  total_a_pagar_psicologos: number;
  saldo: number;
};

export type FinancialReport = {
  periodo: { start: string; end: string };
  total_sessoes: number;
  pendencias_empresas: PendenciaEmpresa[];
  a_pagar_psicologos: PagamentoPsicologo[];
  devedores_colaboradores: DevedorColaborador[];
  lista_recebimentos: FinancialSession[];
  lista_contas_a_pagar: FinancialPayableSession[];
  totais: FinancialTotals;
};

export async function getFinancialReport(
  startDate: string,
  endDate: string
): Promise<FinancialReport> {
  const response = await request.get<{ success: boolean; data: FinancialReport }>(
    `/admnistrador/relatorio-financeiro`,
    { params: { start_date: startDate, end_date: endDate } }
  );
  return response.data.data;
}
